import { CoreError } from './errors'

export const GENERATION_HEADER = 'X-Terysling-Generation'

/** One document's data identity. Another generation never enters its cache;
 * an explicit page reload starts again with empty request and query state. */
export class GenerationFence {
  private generation: string | undefined
  private stale = false
  private readonly listeners = new Set<() => void>()

  readonly subscribe = (listener: () => void): (() => void) => {
    this.listeners.add(listener)
    return () => this.listeners.delete(listener)
  }

  readonly isStale = (): boolean => this.stale

  headers(): Record<string, string> {
    this.assertCurrent()
    return this.generation ? { [GENERATION_HEADER]: this.generation } : {}
  }

  observe(response: Response): void {
    const received = response.headers.get(GENERATION_HEADER)
    if (received) {
      if (this.generation && this.generation !== received) {
        this.stale = true
        for (const listener of this.listeners) listener()
      } else {
        this.generation = received
      }
    }
    this.assertCurrent()
  }

  private assertCurrent(): void {
    if (this.stale) {
      throw new CoreError('conflict', 'Product data changed; reload required', 409, 'product_generation_changed')
    }
  }
}

export const browserGeneration = new GenerationFence()
